export interface Schema {
  skipPackageJson?: boolean;
  path?: string;
  project?: string;
  module?: string;
  storePath?: string;
}
